import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Feb 2026 migration: auth token lives in an HttpOnly `electable_session`
// cookie set by the backend on login. `withCredentials: true` makes axios
// send it automatically on every request. The old Authorization: Bearer
// header path is gone from the browser — nothing here reads localStorage
// for auth anymore.
export const api = axios.create({ baseURL: API, withCredentials: true });

// CSRF (double-submit cookie): read the non-HttpOnly `electable_csrf`
// cookie the backend set at login and mirror its value into an
// X-CSRF-Token header on every state-changing method. Backend rejects
// (403) any authenticated write whose header doesn't match the cookie.
function readCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : "";
}

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (method !== "get" && method !== "head" && method !== "options") {
    const csrf = readCookie("electable_csrf");
    if (csrf) {
      config.headers = config.headers || {};
      config.headers["X-CSRF-Token"] = csrf;
    }
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
